export default __webpack_public_path__ + "static/icon-31-2-3d7c4256aab4a7d70534d72cb8d89a7a.png";